import { render, staticRenderFns } from "./VacanciesWeOfferBlock.vue?vue&type=template&id=07278d23&scoped=true&"
import script from "./VacanciesWeOfferBlock.vue?vue&type=script&lang=js&"
export * from "./VacanciesWeOfferBlock.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesWeOfferBlock.vue?vue&type=style&index=0&id=07278d23&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07278d23",
  null
  
)

export default component.exports